import { render, staticRenderFns } from "./UsablePromotion.vue?vue&type=template&id=77d7d7b2&lang=pug&"
import script from "./UsablePromotion.vue?vue&type=script&lang=js&"
export * from "./UsablePromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports